import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { colors, AppBar, Toolbar } from '@material-ui/core';

import { Image } from 'components/atoms';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    background: theme.palette.white,
    borderBottom: `1px solid ${colors.grey[200]}`,
  },
  toolbar: {
    maxWidth: 1280,
    width: '100%',
    height : 60,
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    
    [theme.breakpoints.up('md')]: {
      height : 80
    }
  },
  logoContainer: {
    width: 172,
    height: 40,
    [theme.breakpoints.up('md')]: {
      width: 215,
      height: 50,
    },
  },
  logoImage: {
    width: '100%',
    height: '100%',
  },
}));

const Topbar = props => {
  const { onSidebarOpen, className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.logoContainer}>
          <a href="/" title="Englewood OHS">
            <Image
              className={classes.logoImage}
              src="/images/logos/0_logo.png"
              alt="Englewood OHS"
              lazy={false}
            />
          </a>
        </div>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
};

export default Topbar;
